import styled from "styled-components";

export const Container = styled.div`
  padding: 16px;
  padding-bottom: 8px;
`;

export const ButtonsWrapper = styled.div`

  .buttonCancel {
    border-radius: 5px !important;
    cursor: pointer !important;
  }

  .buttonSubmit {
    border-radius: 5px;
  }
`;
